import React from 'react';
import BlogsCard from '../BlogsCard/BlogsCard';

import style from './Blogs.module.scss';



const Blogs = () => {

  const blogs = [
    {
      blogId: 1,
      blogImage: "https://i.ibb.co/N33FnbC/DBMS.png",
      blogName: "Dbms",
      blogDetails: "this is my blog 1",
      blogWebsite: "https://www.tutorialspoint.com/dbms/index.htm",
      
    },
    {
      id: 1,
      blogImage: "https://i.ibb.co/XV2pmPL/javascript.png",
      blogName: "ES6",
      blogDetails: "this is my blog 2",
      blogWebsite: "https://www.w3schools.com/js/js_es6.asp",
      
    },
    {
      id: 1,
      blogImage: "https://i.ibb.co/vcXjYNC/c.jpg",
      blogName: "C programming",
      blogDetails: "this is my blog 3",
      blogWebsite: "https://www.programiz.com/c-programming",
      
    }
  ]

  return (
    <div className={style.blogs} id="blogs">
      <div className="container ">
        <div className="projectTitle text-center">
          <h1>My Blogs</h1>

          <div className="row mt-3 gx-2">
          {
            blogs.map(blog => <BlogsCard key={blog.id} blog={blog}></BlogsCard>)
          }
        </div>

        </div>
        
      </div>
    </div>
  );
};

export default Blogs;